var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          staticStyle: { "padding-right": "0px" },
          attrs: {
            model: _vm.form,
            "label-col": _vm.labelCol,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "a-row",
            { staticClass: "flex-row" },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "品系", prop: "strainsNameList" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            gap: "4px",
                            width: "100%",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                mode: "multiple",
                                placeholder: "请选择品系",
                                "collapse-tags": true,
                                disabled: _vm.isDisabled(),
                              },
                              on: { change: _vm.onStrainsChange },
                              model: {
                                value: _vm.form.strainsNameList,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "strainsNameList", $$v)
                                },
                                expression: "form.strainsNameList",
                              },
                            },
                            _vm._l(_vm.carStrainsDS, function (item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.strainsCode,
                                  attrs: { value: item.strains },
                                },
                                [_vm._v(_vm._s(item.strains))]
                              )
                            }),
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#999",
                                "font-size": "12px",
                                "line-height": "1.4",
                              },
                            },
                            [_vm._v(" 注意：公路用车与工程用车不可同时选择 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "平台名", prop: "platform" } },
                    [
                      _c(
                        "a-select",
                        {
                          attrs: { disabled: _vm.isDisabled() },
                          model: {
                            value: _vm.form.platform,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "platform", $$v)
                            },
                            expression: "form.platform",
                          },
                        },
                        [
                          _c(
                            "a-select-option",
                            { attrs: { value: "卡车之家" } },
                            [_vm._v("卡车之家")]
                          ),
                          _c(
                            "a-select-option",
                            { attrs: { value: "运满满" } },
                            [_vm._v("运满满")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "负责人姓名", prop: "headName" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.headName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "headName", $$v)
                          },
                          expression: "form.headName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "负责人电话", prop: "headPhone" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.headPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "headPhone", $$v)
                          },
                          expression: "form.headPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      staticClass: "sign-tiem widthHuo",
                      attrs: { label: "备注", "label-col": { span: 4 } },
                    },
                    [
                      _c("a-textarea", {
                        attrs: {
                          "auto-size": { minRows: 2, maxRows: 6 },
                          disabled: _vm.isDisabled(),
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "item-line" }, [_vm._v("费用预算")]),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "年费", prop: "annualFee" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.annualFee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "annualFee", $$v)
                          },
                          expression: "form.annualFee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "合计" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: "" },
                        model: {
                          value: _vm.form.totalCost,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "totalCost", $$v)
                          },
                          expression: "form.totalCost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.approveBtnDisplay === true
            ? _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "经销商已补差" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.dealerDiff,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "dealerDiff", $$v)
                              },
                              expression: "form.dealerDiff",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "区域已补差" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.areaDiff,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "areaDiff", $$v)
                              },
                              expression: "form.areaDiff",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "最高支持费用" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.isDisabled() },
                            model: {
                              value: _vm.form.maxSupportFee,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "maxSupportFee", $$v)
                              },
                              expression: "form.maxSupportFee",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }